import React from 'react';
import { Area, AreaChart, CartesianGrid, Dot, ResponsiveContainer, Tooltip, XAxis, YAxis, } from 'recharts';

const CustomTooltip = ({ active, payload, label }) => {
  if (active && payload && payload.length) {
    const payloadMin = payload.find((item) => item.name === 'min');
    const payloadMax = payload.find((item) => item.name === 'max');
    return (
      <div className="custom-tooltip">
        <p className="label">Date: {`${label}`}</p>
        <p
          style={{ color: payloadMax?.stroke }}
        >{`Max: ${payloadMax?.value} Mbps`}</p>
        <p
          style={{ color: payloadMin?.stroke }}
        >{`Min: ${payloadMin?.value} Mbps`}</p>
      </div>
    );
  }

  return null;
};

Area.renderDotItem = (option, props) => {
  return <Dot {...props} fill="#0e9347" r={5} />;
};

export const BandWidthChart = ({ height, data = [], yLabel }) => {
  return (
    <ResponsiveContainer width="100%" height={height}>
      <AreaChart width={500} height={400} data={data}>
        <CartesianGrid strokeDasharray="3 3" />
        <XAxis dataKey="name" />
        <YAxis
          label={{ value: yLabel, angle: -90, position: 'insideLeft' }}
          type="number"
        />
        <Tooltip content={<CustomTooltip />} />
        <Area
          type="monotone"
          dataKey="min"
          stackId="1"
          stroke="#FFC94A"
          fill="#1f1e1e"
          strokeWidth={2}
          dot={true}
        />
        <Area
          type="monotone"
          dataKey="max"
          stackId="1"
          stroke="rgb(249, 89, 89)"
          fill="#edf7f1"
          strokeWidth={2}
          dot={true}
        />
      </AreaChart>
    </ResponsiveContainer>
  );
};

export default BandWidthChart;
